import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faPiggyBank } from "@fortawesome/free-solid-svg-icons";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { faPaperPlaneAlt } from "@awesome.me/kit-9096fb77ac/icons/classic/regular";

export function CrewNavigation() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <div>
      <div className="container flex items-center">
        <Tabs defaultValue={currentPath} className="w-full">
          <TabsList className="gap-4">
            <Link to="/dispatch">
              <TabsTrigger
                value="/dispatch"
                className="inline-flex items-center gap-1.5"
                // className={cn(
                //   "font-medium text-black text-sm cursor-pointer p-0 bg-transparent hover:underline hover:decoration-yellow-600 hover:underline-offset-4 inline-flex items-center gap-2 data-[state=active]:shadow-none data-[state=active]:bg-transparent data-[state=active]:underline data-[state=active]:decoration-yellow-600 data-[state=active]:underline-offset-4"
                // )}
              >
                <FontAwesomeIcon icon={faPaperPlane} className="w-3 h-3" />
                <span>Dispatch</span>
              </TabsTrigger>
            </Link>

            <Link to="/timesheets">
              <TabsTrigger
                value="/timesheets"
                className="inline-flex items-center gap-1.5"
                // className={cn(
                //   "font-medium text-black text-sm cursor-pointer p-0 bg-transparent hover:underline hover:decoration-yellow-600 hover:underline-offset-4 inline-flex items-center gap-2 data-[state=active]:shadow-none data-[state=active]:bg-transparent data-[state=active]:underline data-[state=active]:decoration-yellow-600 data-[state=active]:underline-offset-4"
                // )}
              >
                <FontAwesomeIcon icon={faPaperPlaneAlt} className="w-3 h-3" />
                <span>Timesheets</span>
              </TabsTrigger>
            </Link>

            <Link to="/payroll">
              <TabsTrigger
                value="/payroll"
                className="inline-flex items-center gap-1.5"
                // className={cn(
                //   "font-medium text-black text-sm cursor-pointer p-0 bg-transparent hover:underline hover:decoration-yellow-600 hover:underline-offset-4 inline-flex items-center gap-2 data-[state=active]:shadow-none data-[state=active]:bg-transparent data-[state=active]:underline data-[state=active]:decoration-yellow-600 data-[state=active]:underline-offset-4"
                // )}
              >
                <FontAwesomeIcon icon={faPiggyBank} className="w-3 h-3" />
                <span>Payroll</span>
              </TabsTrigger>
            </Link>
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
}
